import { render, staticRenderFns } from "./VehicleTypeDetail.vue?vue&type=template&id=5be1768c&"
import script from "./VehicleTypeDetail.vue?vue&type=script&lang=js&"
export * from "./VehicleTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports